import { WorkspaceResourceFolderType } from "common/interfaces";
import { WorkspaceResourceType } from "common/interfaces";
import { IWorkspaceResource } from "common/interfaces";
import { IWorkspaceResourceFolder } from "common/interfaces";

export interface FolderPathInfo {
    pathParts: string[];
    displayLabel: string;
    folderId: string;
    parentFolderId?: string;
    folderType: WorkspaceResourceFolderType;
}

const MAX_FOLDER_PATH_DEPTH = 4;

export function buildFolderPathFolders(folderId: string, resourceFolders: IWorkspaceResourceFolder[]): IWorkspaceResourceFolder[] {
    const folders: IWorkspaceResourceFolder[] = [];
    let folder = resourceFolders.find(f => f.id === folderId);
    let depth = 0;

    while (folder && depth < MAX_FOLDER_PATH_DEPTH) {
        folders.unshift(folder);
        folder = folder.parentFolderId
            ? resourceFolders.find(f => f.id === folder.parentFolderId)
            : undefined;
        depth++;
    }

    return folders;
}

export function buildFolderPathParts(folderId: string, resourceFolders: IWorkspaceResourceFolder[]): string[] {
    return buildFolderPathFolders(folderId, resourceFolders).map(folder => folder.name);
}

export function getFolderPathsForPresentation(
    presentationId: string,
    resources: IWorkspaceResource[],
    resourceFolders: IWorkspaceResourceFolder[]
): FolderPathInfo[] | undefined {
    const presentationResources = resources.filter(
        r =>
            r.resourceType === WorkspaceResourceType.PRESENTATION &&
            r.resourceId === presentationId &&
            r.folderIds?.length
    );
    if (!presentationResources.length) return [];

    const folderIds = new Set<string>();
    presentationResources.forEach(r => r.folderIds.forEach(id => folderIds.add(id)));

    return Array.from(folderIds).map(folderId => {
        const folder = resourceFolders.find(f => f.id === folderId);

        if (!folder) return undefined;

        const pathParts = buildFolderPathParts(folderId, resourceFolders);
        const displayLabel = pathParts.length > 1 ? pathParts[pathParts.length - 1]! : pathParts[0] ?? "";
        return {
            pathParts,
            displayLabel,
            folderId,
            parentFolderId: folder?.parentFolderId,
            folderType: folder?.folderType ?? WorkspaceResourceFolderType.PERSONAL,
        };
    }).filter(Boolean);
}
